
let DataPage = {
    "operationCenter"    : {},
    "unimil"             : {},
    "partsAndServices"   : {},
    "expanded_portfolio" : {}
};

let NotifyDataPage = {
    "operationCenter"    : [],
    "unimil"             : [],
    "partsAndServices"   : [],
    "expanded_portfolio" : []
}

export function SetListData(value) {
    DataPage = value;
    NotifyDataPage["operationCenter"].forEach(element => {
        element(value['operationCenter']);
    });
    NotifyDataPage["unimil"].forEach(element => {
        element(value['unimil']);
    });
    NotifyDataPage["partsAndServices"].forEach(element => {
        element(value['partsAndServices']);
    });
    NotifyDataPage["expanded_portfolio"].forEach(element => {
        element(value['expanded_portfolio']);
    });
}

export function SetListDataSingle(key, value) {
    DataPage[key] = value;
    NotifyDataPage[key].forEach(element => {
        element(value);
    });
}

export function GetDataPage(key){
    return DataPage[key];
}

export function RegisterDataPage(key, value){
    if(!NotifyDataPage[key]){
        NotifyDataPage[key] = [];
    }
    NotifyDataPage[key].push(value);
}
